
// 4️⃣ `services/metricsService.js`

//Responsibility:** raw API calls + parsing (no React state)

// src/services/metricsService.js
import { normalizeAdvancedGroups } from '../helpers/metrics-normalizer';

export function safeParse(text) {
  try {
    const first = JSON.parse(text);
    if (typeof first === 'string') return JSON.parse(first);
    return first;
  } catch {
    return null;
  }
}

export async function fetchAdvancedMetrics(symbol, headers) {
  const resp = await fetch(
    `https://metrics-8.onrender.com/api/metrics/${encodeURIComponent(symbol)}?quarters=6`,
    { headers }
  );

  if (!resp.ok) return null;

  const rawText = await resp.clone().text();
  let json;

  const contentType = resp.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    try {
      json = await resp.json();
    } catch {
      json = safeParse(rawText);
    }
  } else {
    json = safeParse(rawText);
  }

  // New multi-quarter shape: { quarters, dates, byDate }
  if (json && json.byDate) {
    return json;
  }

  // Legacy fallback: single-quarter shape { efficiency, leverage, profitability }
  const groups = normalizeAdvancedGroups(json);
  return groups ? { quarters: [], dates: [], byDate: {}, ...groups } : null;
}

export async function fetchStockBundle(companyName, headers, exchangeCode) {
  const exchangeParam = exchangeCode ? `?exchange=${encodeURIComponent(exchangeCode)}` : '';
  const lookup = await fetch(
    `https://metrics-8.onrender.com/api/lookup/${encodeURIComponent(companyName)}${exchangeParam}`,
    { headers }
  );

  if (!lookup.ok) throw new Error('Company lookup failed');
  const { symbol } = await lookup.json();

  const stockResp = await fetch(
    `https://metrics-8.onrender.com/api/stock/${encodeURIComponent(symbol)}`,
    { headers }
  );

  if (!stockResp.ok) throw new Error('Stock data fetch failed');
  const data = await stockResp.json();

  return { symbol, data };
}

export async function fetchHistoricalMetrics(symbol, quarters = 6, headers = {}) {
  const res = await fetch(
    `https://metrics-8.onrender.com/api/metrics/history/${encodeURIComponent(symbol)}?quarters=${quarters}`,
    { headers }
  );

  if (!res.ok) {
    throw new Error(`Failed to load historical metrics (status ${res.status})`);
  }

  return await res.json();
}


